import {FETCH_WORK_ORDERS_UPLOADED_IMAGE, RECEIVE_WORK_ORDERS_UPLOADED_IMAGE, 
            FAILED_WORK_ORDERS_UPLOADED_IMAGE, FETCH_WORK_ORDERS_DRIVER_LIST, 
            RECEIVE_WORK_ORDERS_DRIVER_LIST, FAILED_WORK_ORDERS_DRIVER_LIST} from '../actions/aTransporter-WorkOrdersUpload'

const defaultWoUploadedImagetState = {
    uploadedWoImageData: [],
    totalWoImage: 0,
    success: true,  
    inProgress: false
}

export function fetchWoUploadedImage(state = defaultWoUploadedImagetState, action){
    switch (action.type) {
        case FETCH_WORK_ORDERS_UPLOADED_IMAGE:
            return ({uploadedWoImageData: [], totalWoImage: 0, success: true, inProgress: true})
        case RECEIVE_WORK_ORDERS_UPLOADED_IMAGE:
            let arrImages = reverseAndSliceToFiveImages(action.payload.result)
            return Object.assign({}, state, {uploadedWoImageData: arrImages, totalWoImage: action.payload.result.length, 
                                                success: true, inProgress: false})
        case FAILED_WORK_ORDERS_UPLOADED_IMAGE:
            return ({uploadedWoImageData: [], totalWoImage: 0, success: false, inProgress: false})
        default:
            return state
    }
}

const reverseAndSliceToFiveImages = function(imageArr){
    const MAX_IMAGES = 1
    if(imageArr.length > MAX_IMAGES){
        return [imageArr.reverse()[0]]
    }
    return imageArr
}

const defaultWoDriverListState = {
    woDriverList: [],
    totalWo: 0,
    success: true,  
    inProgress: false
}

export function fetchWoDriverList(state = defaultWoDriverListState, action){
    switch (action.type) {
        case FETCH_WORK_ORDERS_DRIVER_LIST:
            return ({woDriverList: [], totalWo: 0, success: true, inProgress: true})
        case RECEIVE_WORK_ORDERS_DRIVER_LIST:
            let payload = sortWoBySeq(action.payload)
            return Object.assign({}, state, {woDriverList: payload, totalWo: payload.length, 
                                                        success: true, inProgress: false})
        case FAILED_WORK_ORDERS_DRIVER_LIST:
            return ({woDriverList: [], totalWo: 0, success: false, inProgress: false})
        default:
            return state
    }
}

const sortWoBySeq = function sortWoBySeq(woArr){
    return woArr.sort(function(a, b) {
        return a.wo_seq - b.wo_seq;
    });
}


// WEBPACK FOOTER //
// ./src/redux/reducers/redTransporter-WorkOrdersUpload.jsx